function sliceArr(data, childrenLength = 1) {
  return Array.from(
    {
      length: Math.ceil(data.length / childrenLength)
    },
    (v, index) => data.slice(index * childrenLength, index * childrenLength + childrenLength)
  );
}
export default sliceArr;
